import script from "./TableView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableView.vue?vue&type=script&lang=ts&setup=true"

import "./TableView.vue?vue&type=style&index=0&id=f4d71cea&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4d71cea"]])

export default __exports__